import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Categories from './pages/Categories';
import Contact from './pages/Contact';
import Government from './pages/Government';
import JobDetails from './pages/JobDetails';
import Jobs from './pages/Jobs';
import Organizations from './pages/Organizations';
import OrganizationDetails from './pages/OrganizationDetails';
import NotFound from './pages/NotFound';
import AdPage1 from './pages/AdPage1';
import AdPage2 from './pages/AdPage2';
import AdPage3 from './pages/AdPage3';
import AdPage4 from './pages/AdPage4';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="categories" element={<Categories />} />
          <Route path="contact" element={<Contact />} />
          <Route path="government" element={<Government />} />
          <Route path="job-details/:slug" element={<JobDetails />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="organizations" element={<Organizations />} />
          <Route path="organization/:slug" element={<OrganizationDetails />} />
          <Route path="ad-page-1" element={<AdPage1 />} />
          <Route path="ad-page-2" element={<AdPage2 />} />
          <Route path="ad-page-3" element={<AdPage3 />} />
          <Route path="ad-page-4" element={<AdPage4 />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;